var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'gallery-container',
    'grid',
    { current: _vm.shirt.is_current_sotw },
  ]},[(_vm.shirt.image_url)?_c('img',{staticClass:"image",attrs:{"src":_vm.shirt.image_url,"alt":""}}):_c('img',{staticClass:"image",attrs:{"src":"/assets/img/fabric-placeholder.png","alt":""}}),_vm._v(" "),(_vm.shirt.sotw_start_date)?_c('div',{staticClass:"sow_date"},[_vm._v("\n    "+_vm._s(_vm.shirt.sotw_start_date)+" - "+_vm._s(_vm.shirt.sotw_end_date)+"\n  ")]):_vm._e(),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.shirt.shirt_title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }